import { render, staticRenderFns } from "./CreateOrganization.vue?vue&type=template&id=b4c22ad6&scoped=true&"
import script from "./CreateOrganization.vue?vue&type=script&lang=js&"
export * from "./CreateOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c22ad6",
  null
  
)

export default component.exports